import React from "react";
import "chart.js/auto";
import { Doughnut } from "react-chartjs-2";

import { useEnquiryAnalyticsQuery } from "state/api";
import Loader from "components/Loader";

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "left",
    },
    title: {
      display: true,
      text: "Customer Response Trends",
    },
    colors: {
      enabled: true,
    },
  },
};

const CustomerTrends = () => {
  let { data: customerResponseStats, isLoading } = useEnquiryAnalyticsQuery();
  customerResponseStats = {
    ...customerResponseStats?.customerResponseTrends,
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Doughnut
          data={{
            labels: customerResponseStats?.labels,
            datasets: [
              {
                label: "# of Responses",
                data: customerResponseStats?.data,
                borderWidth: 1,
              },
            ],
          }}
          options={options}
        />
      )}
    </>
  );
};

export default CustomerTrends;
